/**
 * FavoriteNotice — one sentence when a heart could not be saved.
 *
 * Task 11. The heart answers the finger before the server does (`store/favorites.ts`); when the
 * server then does not take it, the heart goes back — and a heart that silently goes back looks
 * like a button that does not work. So this line says what happened and what to do, above the
 * mini player, until «Скрыть» or the next tap on any heart.
 *
 * «Сейчас играет» covers it: a heart tapped there that fails goes back in front of the listener,
 * and the sentence is waiting when they return to the tabs. The screen fits an iPhone SE row by
 * row (`styles/nowplaying.css`), and a line that appears only on failure has no row to take.
 */

import type { JSX } from 'react';

import { useFavorites } from '../store/favorites';

export const FAVORITE_FAILED_TEXT =
  'Избранное не сохранилось. Проверьте интернет и нажмите ещё раз.';
export const HIDE_LABEL = 'Скрыть';

export function FavoriteNotice(): JSX.Element | null {
  const failed = useFavorites((s) => s.failed);
  if (!failed) return null;
  return (
    <p className="hint" role="status">
      <span>{FAVORITE_FAILED_TEXT}</span>
      <button
        type="button"
        className="linkButton"
        onClick={() => {
          useFavorites.getState().dismiss();
        }}
      >
        {HIDE_LABEL}
      </button>
    </p>
  );
}
